import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'

/**
 * FilterBar - Horizontal row of form controls for filtering
 * Renders FormControl+Select and optional FormControlLabel+Checkbox with consistent styling
 *
 * @param {Array} filters - Filter configs: { type: 'select', id, label, value, onChange, options: [{value, label}], minWidth } or { type: 'checkbox', id, label, checked, onChange }
 * @param {Object} sx - Additional sx styles
 */
export const FilterBar = ({ filters = [], sx = {} }) => {
  if (!filters.length) return null

  return (
    <Box
      sx={{
        mb: 3,
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'auto repeat(2, minmax(0, 1fr))',
          md: 'auto repeat(3, minmax(0, 1fr))',
        },
        alignItems: 'center',
        gap: 2,
        '& > *': { minWidth: 0 },
        ...sx,
      }}
    >
      <FilterListIcon
        sx={{
          color: 'text.secondary',
          fontSize: 20,
          display: { xs: 'none', sm: 'block' },
          gridColumn: { sm: '1' },
          alignSelf: 'center',
        }}
      />
      {filters.map((filter) => {
        if (filter.type === 'checkbox') {
          return (
            <FormControlLabel
              key={filter.id}
              sx={{ m: 0, width: { xs: '100%', sm: 'auto' } }}
              control={
                <Checkbox
                  checked={filter.checked}
                  onChange={(e) => filter.onChange?.(e.target.checked)}
                  size="small"
                />
              }
              label={filter.label}
            />
          )
        }
        // type === 'select' (default)
        const { id, label, value, onChange, options = [], minWidth = 160 } = filter
        return (
          <FormControl
            key={id}
            size="small"
            fullWidth
            sx={{
              minWidth: { xs: 0, sm: minWidth },
              width: { xs: '100%', sm: 'auto' },
            }}
          >
            <InputLabel id={`${id}-label`}>{label}</InputLabel>
            <Select
              labelId={`${id}-label`}
              id={id}
              value={value}
              label={label}
              onChange={(e) => onChange?.(e.target.value)}
            >
              {options.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )
      })}
    </Box>
  )
}
